import React, { useState } from 'react';
import { Modal, Button } from 'antd';
export default function SuccessModal(props) {
    var _a = useState(props.isVisible), visible = _a[0], setVisible = _a[1];
    return (React.createElement(Modal, { title: "\u4F7F\u7528\u987B\u77E5", okText: "\u597D\u7684", visible: visible, onCancel: function () {
            setVisible(false);
        }, footer: [
            React.createElement(Button, { key: "back", onClick: function () {
                    setVisible(false);
                } }, "\u597D\u7684"),
        ], width: 360, style: { top: '30%' } },
        React.createElement("p", null, "\u8BE5\u5E94\u7528\u5DF2\u7533\u8BF7\u8BD5\u7528\u6210\u529F\uFF0C\u60A8\u53EF\u4EE5\u5728\u5DE5\u4F5C\u53F0\u627E\u5230\u5E76\u4F7F\u7528\u8BE5\u5E94\u7528\u3002")));
}
//# sourceMappingURL=SuccessModal.js.map